import { useQuery } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { ContactsSearchResultsRequestDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

export const useGetContacts = (ids: string[]) => {
    const dto: ContactsSearchResultsRequestDto = {
        page: 1,
        pageSize: 100,
        isNewOnly: false,
        excludeUserLeads: false,
        queryFilters: {
            contactsFilters: {},
            leadsFilters: {},
        },
        includeContacts: ids.map((id) => ({ internalContactId: id })),
    };
    return useQuery({
        queryKey: aiAgentQueryKeys.superAgent.contacts(ids),
        queryFn: ({ signal }) =>
            salesApiService.contactsSearch.fetchSearchResults("companies", dto, {
                cancellation: signal,
            }),
        enabled: ids.length > 0,
    });
};
